function ButtonModal({ closeModal, VideoId }) {
    return (
        <>
            <div className="modal-content text-center">
                <div className="modal-header mb-2">
                    <h5 className="modal-title"></h5>
                    <button type="button" onClick={closeModal} className='btn-close' aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    {/* <div class="d-grid gap-2"> */}
                    <iframe sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation" src={`https://www.youtube.com/embed/${VideoId}`} width="465" height="300" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" />
                </div>
            </div>
        </>
    )
}

export default ButtonModal;